import React from 'react'
import logo from './../../assets/logo.png';
import { StyleSheet, Text, View, Image } from "@react-pdf/renderer";
const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',

    },
    logo: {
        width: 150,
        height: 50,
        objectFit: 'contain',
        marginTop: 0,
        marginLeft: 'auto',
        marginBottom: 10,
        marginRight: 'auto'
    },
});

const Header = () => {
    return (
        <View style={styles.headerContainer}>
            <Image style={styles.logo} src={logo} />
            <Text>ISO-9001-2015</Text>
        </View>
    )
}

export default Header